module.exports = __webpack_public_path__ + "static/media/icon_gaotuntu.3c290068.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_gaotuntu.svg
// module id = 126
// module chunks = 0